import { gateway } from "../../../../gateway";

export async function checkActivationTokenAction( payload ) {
  const response = await gateway.post(
    "/users/check-activation-token",
    payload
  );

  return response.data;
}